import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type Theme = "day" | "night";

interface AppState {
  activeChildId: string | null;
  childName: string;
  avatarUrl: string | null;
  stars: number;
  completedTaskIds: string[];
  theme: Theme;
  setActiveChild: (id: string | null, name?: string) => void;
  setChildProfile: (name: string, avatarUrl?: string | null) => void;
  hydrateProgress: (stars: number, completedTaskIds: string[]) => void;
  setStars: (stars: number) => void;
  completeTask: (taskId: string, stars: number) => void;
  toggleTheme: () => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      activeChildId: null,
      childName: "小小探索师",
      avatarUrl: null,
      stars: 12,
      completedTaskIds: [],
      theme: "day",
      setActiveChild: (activeChildId, childName) => set((state) => ({ activeChildId, childName: childName ?? state.childName })),
      setChildProfile: (childName, avatarUrl = null) => set({ childName, avatarUrl }),
      hydrateProgress: (stars, completedTaskIds) => set({ stars, completedTaskIds }),
      setStars: (stars) => set({ stars: Math.max(0, Math.trunc(stars)) }),
      completeTask: (taskId, reward) => set((state) => state.completedTaskIds.includes(taskId) ? state : ({ completedTaskIds: [...state.completedTaskIds, taskId], stars: state.stars + reward })),
      toggleTheme: () => set((state) => ({ theme: state.theme === "day" ? "night" : "day" }))
    }),
    {
      name: "lusky:web-state:v1",
      storage: createJSONStorage(() => localStorage),
      partialize: ({ activeChildId, childName, avatarUrl, stars, completedTaskIds, theme }) => ({ activeChildId, childName, avatarUrl, stars, completedTaskIds, theme })
    }
  )
);
